import { render, staticRenderFns } from "./PEC_img1.vue?vue&type=template&id=15b67c7e"
import script from "./PEC_img1.vue?vue&type=script&lang=js"
export * from "./PEC_img1.vue?vue&type=script&lang=js"
import style0 from "./PEC_img1.vue?vue&type=style&index=0&id=15b67c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports